<template>
  <div class="wltjfx-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="统计日期">
              <el-date-picker v-model="searchForm.time" format="yyyy年MM月dd日" value-format="yyyy-MM-dd" type="daterange"
                :clearable="false" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="品牌">
              <el-select v-model="searchForm.bid" style="width: 120px" clearable>
                <el-option v-for="item in brandList" :key="item.brand_id" :label="item.brand_name"
                  :value="item.brand_id" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
              <el-button icon="el-icon-printer" style="margin-left: 10px;" size="small" :loading="excelLoading"
                @click="exportExcel">导出Excel</el-button>
            </el-form-item>
          </el-form>

          <div class="card-content">
            <el-row :gutter="20" v-loading="loading">
              <el-col :span="24">
                <div style="font-size: 16px; font-weight: bold; padding: 4px 0;">
                  物料总成本：{{ totalCost.toFixed(2) }} 元，总销售额：{{ totalPrice.toFixed(2) }} 元，总利润：{{ totalProfit.toFixed(2) }} 元，利润率：{{ (!totalProfit || !totalPrice) ? 0 : (totalProfit/totalPrice*100).toFixed(2) }}%
                </div>
              </el-col>

              <el-col :span="24" style="padding-top: 10px">
                <el-table
                  ref="table"
                  :data="tableData"
                  stripe style="width: 100%"
                  max-height="700px"
                  row-key="rowKey"
                  lazy
                  :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                  :load="loadChildren"
                >
                  <el-table-column prop="id" label="物料ID" align="left" width="85"></el-table-column>
                  <el-table-column prop="name" label="物料名称" align="center" min-width="150" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="spec" label="物料规格" align="center" min-width="90" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="unit" label="物料单位" align="center" width="75"></el-table-column>
                  <el-table-column prop="cost" label="单位成本" align="center" width="80"></el-table-column>
                  <el-table-column prop="price" label="单位售价" align="center" width="80"></el-table-column>
                  <el-table-column prop="standard" label="物标配数量" align="center" width="85"></el-table-column>
                  <el-table-column prop="count" label="已发货实际销售数量" fixed="right" align="center" width="85"></el-table-column>
                  <el-table-column prop="totalPrice" label="已发货实际销售额" fixed="right" align="center" min-width="95"></el-table-column>
                  <el-table-column prop="totalCost" label="已发货实际总成本" fixed="right" align="center" min-width="95"></el-table-column>
                  <el-table-column prop="totalProfit" fixed="right" align="center" label="已发货实际总利润">
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF">{{ scope.row.totalProfit }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="totalProfitParent" fixed="right" align="center" label="实际利润率(%)">
                    <template slot-scope="scope">
                      <span style="font-weight: 500;">{{ scope.row.totalProfitParent }}%</span>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
              <el-col :span="24"><div style="height: 20px;width: 100%;"></div></el-col>
              <el-col :span="24">
                <GraphicsChart id="circle" :option="circleOption" />
              </el-col>
              <el-col :span="24"><div style="height: 20px;width: 100%;"></div></el-col>
              <el-col :span="24">
                <div class="chart-column">
                  <GraphicsChart id="column" :option="columnOption" />
                </div>
              </el-col>
            </el-row>
          </div>

          <div class="card-content" style="margin-top: 40px; border-top: 1px solid #ebeef5;">
            <el-row :gutter="20" v-loading="loading">
              <el-col :span="24">
                <div style="font-size: 16px; font-weight: bold; padding: 4px 0;">
                  历史总利润统计：共 {{ totalProfit2.toFixed(2) }} 元
                </div>
              </el-col>

              <el-col :span="24" style="padding-top: 10px">
                <el-table :data="tableData2" stripe style="width: 100%" max-height="500px">
                  <el-table-column prop="monthStr" label="月份" align="center" width="160"></el-table-column>
                  <el-table-column prop="count" label="已发货实际销售数量" align="center"></el-table-column>
                  <el-table-column prop="price" label="已发货实际销售额" align="center"></el-table-column>
                  <el-table-column prop="profit" fixed="right" align="center" label="已发货实际总利润">
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF">{{ scope.row.profit }}</span>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
              <el-col :span="24"><div style="height: 20px;width: 100%;"></div></el-col>
              <el-col :span="24">
                <GraphicsChart id="circle" :option="circleOption" />
              </el-col>
              <el-col :span="24"><div style="height: 20px;width: 100%;"></div></el-col>
              <el-col :span="24">
                <div class="chart-column">
                  <GraphicsChart id="line" :option="lineOption" />
                </div>
              </el-col>
            </el-row>
          </div>

        </div>
      </el-col>
    </el-row>

  </div>
</template>

<script>
  import {
    getUser
  } from '@/utils/auth'

  import {
    getMaterialProfit,
    getMaterialProfitDetail,
    exportMaterialProfitExcel,
    getMaterialProfitMonth
  } from '@/api/work'

  import { getBrandSeriesList } from '@/api/pub'

  import axios from 'axios'

  import GraphicsChart from '@/components/Charts/GraphicsChart'

  import {
    getGroupReport
  } from '@/api/pub'

  export default {
    name: 'wltjfx',
    components: {
      GraphicsChart,
    },
    data() {
      return {
        loading: false,
        tableData: [],
        excelLoading: false,

        totalPrice: 0,
        totalCost: 0,
        totalProfit: 0,

        loading2: false,
        tableData2: [],
        totalProfit2: 0,

        searchForm: {
          search: '',
          bid: null,
          time: [],
        },
        brandList: [],

        columnOption: {
          title: false,
          exporting: {
            enabled: true
          },
          credits: {
            enabled: false
          }
        },
        circleOption: {
          title: false,
          exporting: {
            enabled: true
          },
          credits: {
            enabled: false
          }
        },
        lineOption: {
          title: false,
          exporting: {
            enabled: true
          },
          credits: {
            enabled: false
          }
        },

      }
    },
    computed: {
      user: getUser,
    },
    created() {
      this.searchForm.group = this.user.dGroupid
      this.getBrandList()

      const myDate = new Date()
      const year = myDate.getFullYear()
      let month = myDate.getMonth() + 1
      let day = myDate.getDate()
      month = month > 9 ? month + '' : '0' + month
      day = day > 9 ? day + '' : '0' + day
      this.searchForm.time.push(year + '-01-01')
      this.searchForm.time.push(year + '-' + month + '-' + day)

      this.getData()
      this.getData2()
    },
    methods: {
      Search() {
        this.getData()
        this.getData2()
      },

      getBrandList() {
        getBrandSeriesList().then(response => {
          let _brandList = []
          if (this.user.dGroupid === 1) { // 杭州乔金斯
            for (const b of response.data) {
              if (b.brand_id === 3) {
                _brandList.push(b)
              }
            }
          } else if (this.user.dGroupid === 2) { // 耐思迪
            for (const b of response.data) {
              if (b.brand_id === 1 || b.brand_id === 2) {
                _brandList.push(b)
              }
            }
          }
          this.brandList = _brandList
        })
      },

      loadChildren(tree, treeNode, resolve) {
        let startTime = null
        let endTime = null
        if (this.searchForm.time !== null && this.searchForm.time.length === 2) {
          startTime = this.searchForm.time[0]
          endTime = this.searchForm.time[1]
        }
        const data = {
          bid: this.searchForm.bid || null,
          id: tree.id || null,
          start: startTime,
          end: endTime
        }
        getMaterialProfitDetail(data).then(response => {
          let newRow = Object.assign({}, tree)
          let list = response.data || []
          let children = []
          list.forEach(item => {
            children.push({
              ...newRow,
              id: '',
              spec: '',
              unit: '',
              rowKey: 'c' + newRow.id + '_' + item.dealerName,
              hasChildren: false,
              name: item.dealerName,
              count: item.num,
              totalPrice: (item.num * newRow.price).toFixed(2),
              totalCost: (item.num * newRow.cost).toFixed(2),
              totalProfit: (item.num * (newRow.price - newRow.cost)).toFixed(2),
            })
          })
          resolve(children)
        }).catch(() => {})
      },

      getData() {
        if (this.loading) {
          this.$message({
            type: 'warning',
            message: '数据加载中'
          })
          return
        }
        let startTime = ''
        let endTime = ''
        if (this.searchForm.time !== null && this.searchForm.time.length === 2) {
          startTime = this.searchForm.time[0]
          endTime = this.searchForm.time[1]
        }
        const data = {
          page: 1,
          limit: 100000,
          group: this.searchForm.group,
          keyword: this.searchForm.search,
          bid: this.searchForm.bid || null,
          start: startTime,
          end: endTime,
          userid: this.user.dUserid
        }
        this.loading = true
        getMaterialProfit(data).then(response => {
          this.totalPrice = 0
          this.totalCost = 0
          this.totalProfit = 0

          if (this.tableData.length > 0) {
            this.tableData.forEach(row => {
              this.$refs.table.toggleRowExpansion(row, false) // 全部折叠
            })
          }

          let tableData = response.data || []

          for (const item of tableData) {
            this.totalPrice += (item.totalPrice * 1)
            this.totalCost += (item.totalCost * 1)
            this.totalProfit += (item.totalProfit * 1)
            item.hasChildren = true
            item.children = []
            item.rowKey = item.id
          }
          this.tableData = tableData

          this.initCharts(this.tableData)

          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      },

      getData2() {
        if (this.loading2) {
          this.$message({
            type: 'warning',
            message: '数据加载中'
          })
          return
        }
        const data = {
          group: this.searchForm.group,
          userid: this.user.dUserid
        }
        this.loading2 = true
        getMaterialProfitMonth(data).then(response => {
          this.totalProfit2 = 0
          this.tableData2 = response.data || []

          for (const item of this.tableData2) {
            this.totalProfit2 += (item.profit * 1)
          }

          this.initCharts2(this.tableData2)

          this.loading2 = false
        }).catch(() => {
          this.loading2 = false
        })
      },

      initCharts(list) {
        let circleData = []

        let names = []
        let prices = []
        let counts = []
        let costs = []
        let profits = []

        // 按利润降序排序
        list.sort((a, b) => b.totalProfit * 1 - a.totalProfit * 1);
        for (const item of list) {
          circleData.push({
            name: item.name,
            y: item.totalProfit * 1
          });

          names.push(item.name);
          prices.push(item.totalPrice * 1);
          counts.push(item.count * 1);
          costs.push(item.totalCost * 1);
          profits.push(item.totalProfit * 1);
        }

        const circle = {
          lang: {
            printChart: '打印图表',
            downloadPNG: '下载JPEG 图片',
            downloadJPEG: '下载JPEG文档',
            downloadPDF: '下载PDF 图片',
            downloadSVG: '下载SVG 矢量图',
            contextButtonTitle: '下载图片'
          },
          chart: {
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            type: 'pie'
          },
          title: {
            text: '物料总利润占比图'
          },
          credits: {
            enabled: false
          },
          tooltip: {
            headerFormat: '<span style="font-size:11px;">{series.name}: <b>{point.percentage:.2f}%</b></span><br>',
            pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b> 元<br/>'
          },
          plotOptions: {
            pie: {
              allowPointSelect: true,
              cursor: 'pointer',
              dataLabels: {
                enabled: true,
                format: '<b>{point.name}</b>: {point.percentage:.2f} %'
              }
            }
          },
          series: [{
            name: '占比',
            colorByPoint: true,
            data: circleData
          }]
        }
        this.circleOption = circle

        let chart = {
          lang: {
            printChart: '打印图表',
            downloadPNG: '下载JPEG 图片',
            downloadJPEG: '下载JPEG文档',
            downloadPDF: '下载PDF 图片',
            downloadSVG: '下载SVG 矢量图',
            contextButtonTitle: '下载图片'
          },
          chart: {
            type: 'column'
          },
          title: {
            text: '物料销售情况统计图'
          },
          xAxis: {
            title: false,
            categories: names,
            crosshair: true,
            accessibility: {
              description: 'Countries'
            }
          },
          yAxis: {
            min: 0,
            title: false
          },
          legend: {
            align: 'left',
            x: 70,
            verticalAlign: 'top',
            y: 0,
            floating: true,
            backgroundColor: 'var(--highcharts-background-color, #ffffff)',
            borderColor: 'var(--highcharts-neutral-color-20, #cccccc)',
            borderWidth: 1,
            shadow: false
          },
          tooltip: {},
          plotOptions: {
            column: {
              pointPadding: 0.2,
              borderWidth: 0
            }
          },
          series: [{
            name: '销售额',
            data: prices
          }, {
            name: '销售数量',
            data: counts
          }, {
            name: '总成本',
            data: costs
          }, {
            name: '总利润',
            data: profits
          }]
        }
        this.columnOption = chart
      },

      initCharts2(list) {
        let names = []
        let prices = []
        let counts = []
        let profits = []

        let new_list = [...list].reverse();
        for (const item of new_list) {
          names.push(item.monthStr);
          prices.push(item.price * 1);
          counts.push(item.count * 1);
          profits.push(item.profit * 1);
        }

        let chart = {
          lang: {
            printChart: '打印图表',
            downloadPNG: '下载JPEG 图片',
            downloadJPEG: '下载JPEG文档',
            downloadPDF: '下载PDF 图片',
            downloadSVG: '下载SVG 矢量图',
            contextButtonTitle: '下载图片'
          },
          chart: {
            type: 'spline'
          },
          title: {
            text: '月度销售数据图'
          },
          xAxis: {
            categories: names
          },
          yAxis: {
            title: false
          },
          tooltip: {
            crosshairs: true,
            shared: true
          },
          plotOptions: {},
          series: [{
            name: '销售额',
            data: prices
          }, {
            name: '销售数量',
            data: counts
          }, {
            name: '总利润',
            data: profits
          }]
        }
        this.lineOption = chart
      },

      exportExcel() {
        if (!this.excelLoading) {
          this.excelLoading = true
          let startTime = ''
          let endTime = ''
          if (this.searchForm.time !== null && this.searchForm.time.length === 2) {
            startTime = this.searchForm.time[0]
            endTime = this.searchForm.time[1]
          }
          const data = {
            group: this.searchForm.group,
            bid: this.searchForm.bid || null,
            start: startTime,
            end: endTime,
            userid: this.user.dUserid
          }
          this.$message({
            message: '数据正在导出，请稍候'
          })
          exportMaterialProfitExcel(data).then(response => {
            const _this = this
            let xhr = new XMLHttpRequest()
            xhr.open('GET', response.data.dPath, true)
            xhr.responseType = 'blob'
            xhr.onload = function() {
              if (this.status === 200) {
                let blob = this.response
                let a = document.createElement('a')
                a.download = response.data.dName + '.' + response.data.dType
                a.href = window.URL.createObjectURL(blob)
                a.target = '_blank'
                a.click()
                const h = _this.$createElement
                _this.$msgbox({
                  title: '下载提示',
                  message: h('div', {
                    attrs: {
                      style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;'
                    }
                  }, [
                    h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
                    h('a', {
                      attrs: {
                        href: window.URL.createObjectURL(blob),
                        target: '_blank',
                        download: `${response.data.dName}.${response.data.dType}`,
                        style: 'color: #409EFF;text-decoration:underline;'
                      }
                    }, `点击这里`),
                    h('span', null, `重新下载。`)
                  ]),
                  showCancelButton: false,
                  confirmButtonText: '关闭',
                  beforeClose: (action, instance, done) => {
                    done()
                  }
                }).then(action => {})
              }
            }
            xhr.send()
            this.excelLoading = false
          }).catch(() => {
            this.excelLoading = false
          })
        }
      },

    }
  }
</script>

<style>
  .highcharts-credits {
    display: none !important;
  }
</style>
